import { render, staticRenderFns } from "./RideList.vue?vue&type=template&id=2781d315&scoped=true"
import script from "./RideList.vue?vue&type=script&lang=js"
export * from "./RideList.vue?vue&type=script&lang=js"
import style0 from "./RideList.vue?vue&type=style&index=0&id=2781d315&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2781d315",
  null
  
)

export default component.exports